import {
  ReportApi,
  ReportExportFormats,
  ReportTypes,
  ResponseError,
} from '../api-contracts';
import { ApiFactory } from './api';

interface ReportGeneratorRequest {
  entityId: number;
  reportType: 'UndercarriageInspection' | 'BucketInspection';
  exportFormats: string[];
  responseType: 'File' | 'Link';
}

interface ReportGeneratorResponse {
  error?: string;
  success: boolean;
  data?: ArrayBuffer;
  filename?: string;
}

export class ReportService {
  private api: ReportApi;
  constructor() {
    this.api = ApiFactory.getReportApi();
  }

  getFileNameFromHeader(headers: Headers): string | null {
    const disposition = headers.get('content-disposition');
    if (!disposition) return null;

    const filenameMatch = disposition.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
    );
    if (!filenameMatch) return null;

    return filenameMatch[1].replace(/['"]/g, '');
  }

  async getReport(
    props: ReportGeneratorRequest,
  ): Promise<ReportGeneratorResponse> {
    let response;
    try {
      response = await this.api.generateReportRaw({
        reportGeneratorRequest: {
          $type: props.reportType,
          entityId: props.entityId,
          reportType: props.reportType as ReportTypes,
          exportFormats: (props.exportFormats as ReportExportFormats[]) ?? [
            'Word',
          ],
          responseType: props.responseType,
        },
      });
    } catch (error) {
      if (!(error instanceof ResponseError)) throw error;
      const body = await error.response.text();
      return {
        success: false,
        error: `Failed to get inspection report: {Status: ${error.response.status}}${body ? ` ${body}` : ''}`,
      };
    }

    const buffer = await response.raw.arrayBuffer();

    return {
      success: true,
      data: buffer,
      filename:
        this.getFileNameFromHeader(response.raw.headers) ?? 'report.docx',
    };
  }
}
